import { OrganizationContact } from '@medplum/fhirtypes';
import { Avatar } from '@mantine/core';
import { PartnerContactAvatar } from './PartnerContactAvatar';
export function ContactsAvatarGroup({ contacts }: { contacts: OrganizationContact[] }) {
  return (
    <Avatar.Group spacing="sm">
      {contacts?.length > 0
        ? contacts.map((contact, index) => {
            return (
              <PartnerContactAvatar
                key={`${contact.name?.family}-${contact.name?.given?.[0]}-${index}`}
                contact={contact}
              />
            );
          })
        : '-'}
    </Avatar.Group>
  );
}
